import { matchPath } from 'react-router-dom';
import { HELP_MANUAL, type HelpGroup, type HelpModule } from '@/data/helpManual';
import type { AppRole } from '@/contexts/AuthContext';

export function findModuleForPath(
  pathname: string,
  currentRole: AppRole | null
): { module: HelpModule; group: HelpGroup } | null {
  // Caso especial: /dashboard depende del rol activo.
  if (pathname === '/dashboard') {
    if (currentRole === 'admin' || currentRole === 'super_admin') {
      const group = HELP_MANUAL.find((g) => g.id === 'gobernar');
      const mod = group?.modules.find((m) => m.id === 'rol-admin');
      if (group && mod) return { module: mod, group };
    }
    return null;
  }

  const preferredGroupId: HelpGroup['id'] | null =
    currentRole === 'admin' || currentRole === 'super_admin'
      ? 'gobernar'
      : currentRole === 'participant'
        ? 'aprender'
        : null;

  const orderedGroups = preferredGroupId
    ? [...HELP_MANUAL].sort((a, b) =>
        a.id === preferredGroupId ? -1 : b.id === preferredGroupId ? 1 : 0
      )
    : HELP_MANUAL;

  for (const group of orderedGroups) {
    for (const mod of group.modules) {
      for (const pattern of mod.routePatterns) {
        if (matchPath({ path: pattern, end: true }, pathname)) {
          return { module: mod, group };
        }
      }
    }
  }
  return null;
}

